"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const CompactWorkItem_1 = __importDefault(require("@Components/WorkItemV2/CompactWorkItem"));
const get_catalog_path_1 = __importDefault(require("@App/helpers/work-entities/utils/get-catalog-path"));
const ShareDisplay_1 = require("@Components/WorkItemV2/ShareDisplay");
const contexts_1 = require("@App/contexts");
const CatalogCompactWorkItemHeader_1 = __importDefault(require("@Components/WorkItemV2/Catalog/CatalogCompactWorkItem/CatalogCompactWorkItemHeader"));
const CatalogCompactWorkItem = (props) => {
    const { handleOnClick, yourShares, work } = props;
    const { rightsholderStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const catalogPath = (0, get_catalog_path_1.default)(work.isComplete, rightsholderStore.currentRightsholderId, work.id || 0);
    return (react_1.default.createElement(CompactWorkItem_1.default, { work: work, catalogPath: catalogPath, handleOnClick: handleOnClick },
        react_1.default.createElement("div", { className: 'container shares-group' },
            yourShares && react_1.default.createElement(ShareDisplay_1.ShareDisplay, { share: yourShares, title: 'Your Shares' }),
            react_1.default.createElement(ShareDisplay_1.ShareDisplay, { share: work.totalKnownShares, title: 'Total Known Shares', highlight: true }))));
};
CatalogCompactWorkItem.headerType = CatalogCompactWorkItemHeader_1.default;
exports.default = CatalogCompactWorkItem;
